import { Customer } from "../models";

// Helper function to find potential customer matches
export const findPotentialCustomerMatches = (customers: Customer[], orderCustomer: any): Customer[] => {
  if (!orderCustomer) return [];
  
  const matches: Customer[] = [];
  const orderCustomerName = orderCustomer.name || `${orderCustomer.firstName || ""} ${orderCustomer.lastName || ""}`.trim();
  const orderOrgNumber = orderCustomer.organizationNumber;
  
  customers.forEach(customer => {
    const customerName = Customer.getCustomerName(customer);
    
    // Exact match by organization number (highest priority)
    if (orderOrgNumber && customer.organizationNumber === orderOrgNumber) {
      matches.unshift(customer); // Add to beginning
      return;
    }
    
    // Name match (case insensitive)
    if (orderCustomerName && customerName) {
      if (customerName.toLowerCase() === orderCustomerName.toLowerCase()) {
        matches.push(customer);
        return;
      }
      
      // Partial name match (for fuzzy matching)
      if (customerName.toLowerCase().includes(orderCustomerName.toLowerCase()) || 
          orderCustomerName.toLowerCase().includes(customerName.toLowerCase())) {
        matches.push(customer);
      }
    }
  });
  
  // Remove duplicates and return
  return Array.from(new Map(matches.map(customer => [customer.id, customer])).values());
};

// Helper function to search customers by text
export const searchCustomers = (customers: Customer[], searchText: string): Customer[] => {
  if (!searchText || searchText.length === 0) return customers;
  
  const searchLower = searchText.toLowerCase();
  return customers.filter(customer => {
    const customerName = Customer.getCustomerName(customer);
    const email = Customer.getCustomerEmail(customer);
    const orgNumber = customer.organizationNumber || "";
    
    return (
      customerName.toLowerCase().includes(searchLower) ||
      email.toLowerCase().includes(searchLower) ||
      orgNumber.includes(searchLower)
    );
  });
}; 